<nav class="nav flex-column" role="navigation">
  <div class="nav-item">
    <a routerLink="/home" [routerLinkActiveOptions]='{ exact: true }' routerLinkActive="active" class="nav-link text-nowrap"><i class="fas fa-home" aria-hidden="true"></i><span class="navtext">Home</span></a>
  </div>
  <div *removeIfUnauthorized="hasAdmin.concat(hasPowerUser).concat(hasCDSApprover)" class="nav-item">
    <a *removeIfUnauthorized="hasAdmin.concat(hasCDSApprover)" routerLink="/admin" routerLinkActive="active" class="nav-link text-nowrap">
      <i class="fas fa-cogs" aria-hidden="true"></i><span class="navtext">Administration</span>
    </a>
    <a *removeIfNoPermission="canImport" routerLink="/import-events" routerLinkActive="active" class="nav-link text-nowrap">
      <i class="fas fa-file-import" aria-hidden="true"></i><span class="navtext">Import Events</span>
    </a>
    <a *removeIfNoPermission="canMerge" routerLink="/manageduplicates" routerLinkActive="active" class="nav-link text-nowrap">
      <i class="fas fa-columns" aria-hidden="true"></i><span class="navtext">Manage Duplicates</span>
    </a>
  </div>
  <div class="nav-item">
    <a routerLink="crime-guns" routerLinkActive="active" class="nav-link text-nowrap">
      <i class="icon icon-gun-cases" aria-hidden="true"></i><span class="navtext">Crime Gun Cases</span>
    </a>
  </div>
  <div class="nav-item">
    <a routerLink="/search" routerLinkActive="active" class="nav-link text-nowrap">
      <i class="icon icon-pistol" aria-hidden="true"></i><span class="navtext">Ballistic Evidence</span>
    </a>
  </div>
  <div *removeIfNoPermission="canExport" class="nav-item">
    <a routerLink="/exports" routerLinkActive="active" class="nav-link text-nowrap">
      <i class="fas fa-file-export" aria-hidden="true"></i><span class="navtext">Exports</span>
    </a>
  </div>
  <div class="nav-item">
    <a routerLink="/events" routerLinkActive="active" class="nav-link text-nowrap">
      <i class="fas fa-clipboard-list" aria-hidden="true"></i><span class="navtext">Events</span>
    </a>
    <a routerLink="/people" routerLinkActive="active" class="nav-link text-nowrap">
      <i class="fas fa-users" aria-hidden="true"></i><span class="navtext">People</span>
    </a>
    <a routerLink="/locations" routerLinkActive="active" class="nav-link text-nowrap">
      <i class="fas fa-globe" aria-hidden="true"></i><span class="navtext">Locations</span>
    </a>
  </div>
  <div *removeIfNoPermission="canViewIR" class="nav-item">
    <a routerLink="/info-reports" routerLinkActive="active" class="nav-link text-nowrap">
      <i class="fas fa-file-invoice" aria-hidden="true"></i><span class="navtext">Information Reports</span>
    </a>
  </div>
  <div class="nav-item">
    <a routerLink="/results" routerLinkActive="active" class="nav-link text-nowrap">
      <i class="fas fa-book" aria-hidden="true"></i><span class="navtext">Results</span>
    </a>
  </div>
</nav>
